
import Vue from "vue";
import { marked } from "marked";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";

interface DataType {
  notFound: boolean;
  content: string;
}

interface MethodType {
  init: () => void;
}

interface ComputedType {
  converted: string;
}

export default Vue.extend({
  name: "Report",
  components: {
    Headline,
    Breadcrumb,
    BreadcrumbItem,
  },
  data(): DataType {
    return {
      notFound: false,
      content: "",
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const { name } = this.$route.params;
      fetch(`/api/reports/${name}`).then(res => res.text()).then(text => {
        console.log("fetch", text);
        this.content = text;
      });
    },
  },
  computed: {
    converted(): string {
      if (!this.content) {
        return "";
      }
      return marked(this.content);
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, unknown>);
